// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ICWim";
export var title = "styles-module__title___g86hO";
export var fader = "styles-module__fader___x1v_Y";
export var slidingTabsBorder = "styles-module__slidingTabsBorder___gg3gp";
export var tabRoot = "styles-module__tabRoot___t9BfZ";
export var tabsScroller = "styles-module__tabsScroller___Lzl6b";
export var tabWrapper = "styles-module__tabWrapper___r6ad9";
export var tabsRoot = "styles-module__tabsRoot___MvNgD";
export var flexContainer = "styles-module__flexContainer___IXyYH";
export var scrollButtons = "styles-module__scrollButtons___fwTQN";
export var selectedTab = "styles-module__selectedTab___I1eie";